module.exports = __webpack_public_path__ + "img/explicacao3.0871e257.png";